"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareUsersOnlineFirst = exports.isUserOnline = exports.fromUserSummary = exports.fromMyProfile = void 0;
function fromMyProfile(myProfile) {
    return {
        userId: myProfile.userId,
        username: "You",
        usernameLower: "you",
        isOnline: true,
        imageId: myProfile.imageId,
        chatId: null
    };
}
exports.fromMyProfile = fromMyProfile;
function fromUserSummary(user) {
    return {
        userId: user.userId,
        username: user.username,
        usernameLower: user.usernameLower,
        isOnline: user.minutesSinceLastOnline < 2,
        imageId: user.imageId,
        chatId: user.chatId
    };
}
exports.fromUserSummary = fromUserSummary;
function isUserOnline(user) {
    return user.minutesSinceLastOnline < 2;
}
exports.isUserOnline = isUserOnline;
function compareUsersOnlineFirst(u1, u2) {
    if (u1.isOnline != u2.isOnline) {
        return u1.isOnline ? -1 : 1;
    }
    return (u1.usernameLower < u2.usernameLower) ? -1 : (u1.usernameLower > u2.usernameLower) ? 1 : 0;
}
exports.compareUsersOnlineFirst = compareUsersOnlineFirst;
